/**
 * Created by lzy 19-11-03
 * 百家号渠道待审
 */
'use strict';
angular.module('editBaijiahaoPendingModule', ['editBaijiahaoPendingRouterModule']).controller('EditBaijiahaoPendingCtrl', [
    '$scope',
    '$state',
    'trsHttpService',
    'modalDialog',
    'trsspliceString',
    'baijiahaoService',
    '$q',
    'storageListenerService',
    'editingCenterService',
    'editcenterRightsService',
    'newMediaService',
    'baijiaConst',
    'messagePublishService',
    'editingMediatype',
    '$filter',
    function(
        $scope,
        $state,
        trsHttpService,
        modalDialog,
        trsspliceString,
        baijiahaoService,
        $q,
        storageListenerService,
        editingCenterService,
        editcenterRightsService,
        newMediaService,
        baijiaConst,
        messagePublishService,
        editingMediatype,
        $filter
    ) {
        initStatus();
        initData();

        /**
         * [initStatus description] 初始化状态
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.status = {
                channelId: $state.params.account,
                mediaType: editingMediatype.baijiahao,
                hasphoto: false, // 是否是图集稿
                hasphotoflag: true, // 判断是否人为点击图集切换模式
                status_model: 1,
                isEsSearch: false, // 判断是否是经过ES检索之后
            };
            $scope.childStatus = {
                // 图片数组的string
                checkString: 'DOC_PICTURELIST',
                // 图片数组中表示url地址的string
                picString: 'SRCPICURL',
                originPicUrl: 'SRCPICURL'
            };
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 20,
                ITEMCOUNT: 0,
                PAGECOUNT: 1,
            };
            $scope.data = {
                selectedArray: [],
                items: [],
                keyWords: '',
                account: $state.params.account,
                filterReviseItem: [],
                trench: baijiaConst.listenStroageKey
            };
            $scope.esparams = {}; // es检索参数
            $scope.params = {
                serviceid: 'mlf_baijiahao',
                methodName: 'queryToAudit',
                accountId: $state.params.account,
                PageSize: $scope.page.PAGESIZE,
                CurrPage: $scope.page.CURRPAGE,
                timeType: 0,
                OperTimeStart: $scope.data.fromdate,
                OperTimeEnd: $scope.data.untildate,
                isPass: false,
            };
        }

        /**
         * [initData description]初始化数据
         * @return  {[type]}  [return description]
         */
        function initData() {
            initDropdown();
            // requestData();
            listenStorage();
            initBtnRights();
            refreshList();
        }

        // 用于记忆功能，在app.js中$transitions.onSuccess方法中调用
        $scope.requestData = function() {
            requestData();
        };
        
        /**
         * [initData description]初始化选择类型
         * @return  {[type]}  [return description]
         */
        function initDropdown() {
            $scope.data.docTypeJsons = baijiahaoService.initSelect();
            $scope.data.selectedDocType = angular.copy($scope.data.docTypeJsons[0]);
            // editingCenterService.dealStorage($scope);
        }

        /**
         * [refreshList description]刷新列表
         * @return  {[undefined]}  [return description]
         */
        function refreshList() {
            messagePublishService.subscribe(
                'refresh',
                function(event, data) {
                    if (typeof (data) === 'object') {
                        $scope.status.isEsSearch = true; // es检索状态
                        $scope.esparams = data;
                    } else {
                        $scope.status.isEsSearch = false;
                    }
                    $scope.page.CURRPAGE = 1;
                    requestData();
                },
                $scope
            );
        }

        /**
         * [listenStorage description]监听本地缓存
         * @return {[promise]} [description] promise
         */
        function listenStorage() {
            storageListenerService.listenBaijiahao(function() {
                $scope.status.isEsSearch = false;
                requestData();
                storageListenerService.removeListener('baijiahao');
            }, $scope);
        }

        /**
         * [requestData description]数据请求
         * @return {[type]} [description]
         */
        function requestData() {
            var params = {};
            if ($scope.status.isEsSearch) {
                params = $scope.esparams;
                params.searchParams.PAGEINDEX = $scope.page.CURRPAGE;
            } else {
                params = $scope.params;
                params.CurrPage = $scope.page.CURRPAGE;
            }
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                if (!$scope.status.isEsSearch) {
                    $scope.data.keyWords = '';
                }
                $scope.data.items = data.DATA;
                if ($scope.data.selectedDocType.value && $scope.data.selectedDocType.value === '2' && $scope.status.hasphotoflag === true) {
                    $scope.status.hasphoto = true;
                } else {
                    $scope.status.hasphoto = false;
                }
                storageListenerService.previewPageTurningStorage($scope.data.items, 'METADATAID,MEDIATYPE,DOCMODIFYSTATUSNAME', 'newMediaPreview');
                if ($scope.data.items.length) {
                    editingCenterService.queryVerifyDoc($scope.data.items).then(function(data) {
                        $scope.data.filterReviseItem = $scope.data.items.filter((item) => item.APPSTATUSNAME !== '待修订' && item.verifyDocIsCanOper);
                    });
                }
                requestListImg(data.DATA).then(function(imgdata) {
                    angular.forEach(data.DATA, function(value, key) {
                        value.ALLIMG = imgdata[value.METADATAID];
                    });
                });
                newMediaService.getReviseInfo(data.DATA);
                $scope.page.ITEMCOUNT = data.PAGER.ITEMCOUNT;
                $scope.data.selectedArray = [];
            });
        }

        /**
         * [requestListImg description:查询列表图示]
         * @param  {[type]} items [description] 稿件列表数据
         * @return {[type]} [description]
         */
        function requestListImg(items) {
            var defer = $q.defer();
            if (!items || items.length < 1) {
                defer.resolve([]);
            } else {
                var params = {
                    serviceid: 'mlf_baijiahao',
                    methodname: 'queryAllImgLogo',
                    baiJiaHaoArticleIds: trsspliceString.spliceString(items, 'METADATAID', ','),
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    defer.resolve(data);
                });
            }
            return defer.promise;
        }

        /**
         * [initBtnRights description]初始化百家号操作权限
         * @return  {[type]}  [return description]
         */
        function initBtnRights() {
            editcenterRightsService.initBaiJiaHaoListBtn('baijiahao.daishen', $scope.status.channelId).then(function(rights) {
                $scope.status.btnRights = rights;
            });
        }
        $scope.baijiahaoEditor = function(item) {
            if (item.STATUS === '23') {
                modalDialog.alertType('宣传部送审中的稿件不能编辑', '', 'warning', false);
                return;
            }
            baijiahaoService.baijiahaoEditor(item.DOCTYPEID, item.BAIJIAHAOACCOUNTID, item.METADATAID, 1);
        };

        /**
         * [atlasMode description] 图集模式
         * @return {[type]} [description]
         */
        $scope.atlasMode = function() {
            // $scope.departListParams.CurrPage = $scope.page.CURRPAGE = 1;
            $scope.status.hasphoto = !$scope.status.hasphoto;
            $scope.status.hasphotoflag = !$scope.status.hasphotoflag;
        };

        /**
         * [queryByDropdown description]按照时间搜索
         * @param   {[type]}  type  [type description] 搜索类型
         * @param   {[type]}  val   [val description] 搜索值
         * @return  {[type]}        [return description]
         */
        $scope.queryByDropdown = function(type, val) {
            if (type === 'DocType') {
                $scope.params.DocType = val;
            } else {
                $scope.params.OperTimeStart = $scope.data.fromdate;
                $scope.params.OperTimeEnd = $scope.data.untildate;
            }
            if (type === 'DocType' && val === '2') {
                $scope.status.hasphotoflag = true;
            }
            $scope.page.CURRPAGE = 1;
            if ($scope.status.isEsSearch) {
                messagePublishService.publish('changeEsParams');
            } else {
                requestData();
            }

        };

        /**
         * [selectAll description]全选
         * @return  {[type]}  [return description]
         */
        $scope.selectAll = function() {
            $scope.data.selectedArray =
                $scope.data.selectedArray.length === $scope.data.filterReviseItem.length ? [] : [].concat($scope.data.filterReviseItem);
        };

        /**
         * [selectDoc description] 单选
         * @param  {[type]} item [description] 选中的文件
         * @return {[type]}      [description]
         */
        $scope.selectDoc = function(item) {
            if ($scope.data.selectedArray.indexOf(item) < 0) {
                $scope.data.selectedArray.push(item);
            } else {
                $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(item), 1);
            }
        };

        /**
         * [goToDetail description]图集模式跳转细览页
         *
         * @param   {[type]}  item  [item description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.goToDetail = function(item){
            var params = {
                mediatype: 18,
                metadataid: item.BAIJIAHAOARTICLEID,
                isawaitrevise: item.DOCMODIFYSTATUSNAME
            };
            var url = $state.href('newMediaPreview', params);
            window.open(url);
        };

        /**
         * [isChecked description] 选中状态
         * @param  {[type]}  item [description]
         * @return {Boolean}      [description]
         */
        $scope.isChecked = function(item) {
            if (!item) {
                return;
            }
            var ischecked = false;
            for (var i = 0; i < $scope.data.selectedArray.length; i++) {
                if ($scope.data.selectedArray[i].METADATAID == item.METADATAID) {
                    ischecked = true;
                    break;
                }
            }
            return ischecked;
        };

        /**
         * [sign description]稿件签发
         *
         * @return {[type]} [description]
         */
        $scope.sign = function() {
            if ($scope.data.selectedArray.length > 1) {
                modalDialog.alertType('', '每次最多签发一个稿件', 'warning', false);
                return;
            }
            if ($scope.data.selectedArray[0].STATUS === '23') {
                modalDialog.alertType('宣传部送审中的稿件不能签发', '', 'warning', false);
                return;
            }
            $scope.loadingPromise = newMediaService.sign($scope, baijiaConst.sign, function(params, selectedArray) {
                params.baiJiaHaoArticleId = selectedArray[0].DOC.METADATAID;
            }
            );
        };
        // 撤稿操作
        $scope.trial = function() {
            $scope.loadingPromise = newMediaService.rejection($scope, baijiaConst.drawNews);
        };

        /**
         * [directSigned description]宣传部送审
         * @return {[type]}      [description]
         */
        $scope.propagandaReview = function() {
            var reviewArray = $scope.data.selectedArray.filter(function(item) {
                return item.STATUS === '23';
            });
            if (reviewArray.length > 0) {
                modalDialog.alertType('审核中的稿件不能送审', trsspliceString.spliceString(reviewArray, 'TITLE', ','), 'warning', 'cancel');
                return;
            }
            newMediaService.propagandaReview($scope, baijiaConst.propagandaReview);
        };


        /**
         * [exportDraft description:导出稿件]
         * @return  {[type]}           [return description]
         */
        $scope.exportDraft = function() {
            if (!isVideoDrafe('只能导出新闻稿或图集稿')) {
                return;
            }
            newMediaService.export(
                angular.extend(
                    {
                        baiJiaHaoArticleIds: trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ','),
                        accountId: $state.params.account,
                    },
                    baijiaConst.exportDraft
                ), $scope.data.selectedArray);
        };

        /**
         * [outSending description：外发]
         * @return  {[type]}           [return description]
         */
        $scope.outSending = function() {
            if (!isVideoDrafe('视频稿不能邮件外发')) {
                return;
            }
            $scope.loadingPromise = newMediaService.outsource(
                angular.extend(
                    {
                        baiJiaHaoArticleIds: trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ','),
                        accountId: $state.params.account,
                    },
                    baijiaConst.outSendingDraft
                ), $scope.data.selectedArray);
        };

        /**
         * [isVideoDrafe description]判断是否是视频稿
         * @param   {[type]}  message  [message description] 选中视频稿时的提示信息
         * @return  {[type]}           [return description]
         */
        function isVideoDrafe(message) {
            if (!$scope.data.selectedArray.length) {
                modalDialog.alertType('', '请选择稿件', 'warning', false);
                return false;
            }
            for (var i = 0; i < $scope.data.selectedArray.length; i++) {
                if ($scope.data.selectedArray[i].DOCTYPEID === '7') {
                    modalDialog.alertType('', message, 'warning', false);
                    return false;
                }
            }
            return true;
        }

        /**
         * [draftlist description]发稿单
         * @return {[type]} [description]
         */
        $scope.draftlist = function() {
            newMediaService.draftlist($scope, baijiaConst.draftListDS, baijiaConst.draftListQuery);
        };

        /**
         * [pageChanged description]翻页
         * @return  {[type]}  [return description]
         */
        $scope.pageChanged = function() {
            $scope.loadingPromise = requestData();
        };

        /**
         * [jumpToPage description]跳页
         * @return  {[type]}  [return description]
         */
        $scope.jumpToPage = function() {
            $scope.page.CURRPAGE = angular.copy($scope.status.copyCurrPage);
            $scope.loadingPromise = requestData();
        };

        /**
         * [revise description] 修订方法
         * @return  {[type]}  [return description]
         */
        $scope.revise = function() {
            var params = {
                DocIds: trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ','),
                MediaType: '18',
            };
            newMediaService.revise($scope, params);
            // $scope.status.isEsSearch = false;
            // editingCenterService.channelsRevise(
            //     params,
            //     function(data) {
            //         requestData();
            //     },
            //     function() {}
            // );
        };

        /**
         * [processRecord description] 获取企鹅号流程记录
         * @param   {[type]}  item  [item description] 选中的企鹅号稿件
         * @return  {[type]}        [return description]
         */
        $scope.processRecord = function(item) {
            item.SCMMICROCONTENTID = item.METADATAID;
            item.MEDIATYPE = $scope.status.mediaType;
            // editingCenterWeiBoService.processRecord(item);
            editingCenterService.getVersionTime(item, false);
        };

        /**
         * [distribution description]多元分发
         *
         * @return  {[type]}  [return description]
         */
        $scope.distribution = function() {
            $scope.status.isEsSearch = false;
            if (!editingCenterService.isSameDocType($scope.data.selectedArray, 'DOCTYPEID')){
                modalDialog.alertType('', '多元分发仅支持相同类型的稿件', 'warning', 'confirm', function () { });
                return;
            }
            var temp = $filter('pick')($scope.data.selectedArray, $scope.examDistributionType);
            if (temp.length < 1) {
                editingCenterService.distribution($scope.data.selectedArray, '18', $scope.data.selectedArray[0].DOCTYPEID, 'baiJiaDaiShenDistribute', function() {
                    $scope.data.selectedArray = [];
                    requestData();
                    // modalDialog.alertType("发稿单修改成功", "", "success", false, function() {
                    // });
                });
            } else {
                modalDialog.alertType('', '多元分发仅支持的稿件类型为新闻、视频、图集', 'warning', 'confirm', function() {});
            }
        };

        /** 多元分发稿件类型  新闻:1、图集:2、链接:4、视频:8、app直播:7
         * [examDistributionType description]
         * @param  {[type]} elm [description]
         * @return {[type]}     [description]
         */
        $scope.examDistributionType = function(elm) {
            if (angular.isDefined(elm)) {
                return elm.DOCTYPEID != 1 && elm.DOCTYPEID != 7 && elm.DOCTYPEID != 2;
            }
        };

        /**
         * [isOnlyMine description] 只看我的/只看通过
         *
         * @param {[type]} key   [key description] 代表是改变通过还是我的的状态
         *
         * @return {[type]}   [return description] null
         */
        $scope.isOnlyMine = function(key) {
            $scope.page.CURRPAGE = '1';
            $scope.params[key] = !$scope.params[key];
            if ($scope.status.isEsSearch) {
                messagePublishService.publish('changeEsParams');
            } else {
                requestData();
            }
        };
    },
]);
